<template>
  <div class="rewards-info">
    <div class="r-row">
      <h2 class="title w-100">KUNI MINER</h2>
      <div class="lb-action">
        <reward-label
          :symbol="'GE'"
          :srcIcon="geIcon"
          :isLoading="isLoading"
          :isConnected="isConnected"
          :balance="mData.ge"
        />
        <b-overlay
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="is-claim d-inline-block"
        >
          <b-button
            :disabled="!isConnected"
            class="btn-earn w-100"
            @click="$emit('onBoost')"
          >
            <img src="~@/assets/icons/plus.svg" />Boost
          </b-button>
        </b-overlay>
      </div>
    </div>
    <div class="r-row is-column">
      <reward-label
        :symbol="'Hash Rate'"
        :srcIcon="energyIcon"
        :isLoading="isLoading"
        :isConnected="isConnected"
        :balance="mData.aStaked"
      />
      <div class="lb-action">
        <reward-label
          :symbol="mData.kuniSymbol"
          :srcIcon="kuniIcon"
          :isLoading="isLoading"
          :isConnected="isConnected"
          :balance="mData.kuniBalance"
        />

        <b-overlay
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="is-claim d-inline-block w-100"
        >
          <b-button
            :disabled="!isConnected"
            class="btn-earn w-100"
            @click="$emit('onClaim')"
          >
            <img src="~@/assets/icons/plus.svg" />Claim
          </b-button>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import kuniIcon from "@/assets/icons/kuni.svg";
import energyIcon from "@/assets/icons/energy.png";
import geIcon from "@/assets/icons/green-energy.png";

export default {
  name: "KuniMinter",
  props: ["isConnected", "isLoading", "mData"],
  data: () => ({
    kuniIcon,
    energyIcon,
    geIcon,
  }),
};
</script>

<style lang="scss" scoped>
.rewards-info {
  @media (min-width: 768px) and (max-width: 1024px) {
    margin: 0px auto;
  }

  .r-row {
    display: flex;
    flex-direction: row;
    gap: 15px;
    justify-content: space-between;
  }

  @media (max-width: 767px) {
    .r-row {
      flex-direction: column;
      gap: 15px;
      &.is-column {
        padding-top: 16px;
      }
      .lb-action {
        .is-claim {
          width: 100%;
        }
      }
    }
  }

  .lb-action {
    display: flex;
    flex: colunm;
    gap: 15px;
  }

  .title {
    flex: 1;
    color: var(--Red, #eb345f);
    font-family: Bebas Neue;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: 57px;
    line-height: normal;
    margin-bottom: 8px;
  }

  .btn-earn {
    display: inline-flex;
    height: 48px;
    padding: 8px 20px 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: transparent;
    &:active,
    &:focus {
      box-shadow: none;
    }
    &:disabled,
    &.disabled {
      cursor: not-allowed;
    }
  }
}
</style>
